<template>
  <div class="card mb-25 border-0 rounded-0 bg-white monthly-new-customers-box radius-7 heigth-other-cards-dashboard">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-size-card spacing-cards-dashboard">
      <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard">Tamanho total de gravação</span>
      <h4 class="fw-black mb-12 lh-1 font-size-32">{{ (getDashboardDayCards.total_size / (1024 * 1024)).toFixed(2) + " MB" }}</h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "DashboardDaySize",
  computed:{
    ...mapGetters([
      'getDashboardDayCards'
    ])
  },
};
</script>